import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { userData } from 'selectors/user';

import { FormattedMessage } from 'react-intl';
import { Box, Button, makeStyles } from '@material-ui/core';

import Dac7InfoDialog from '../components/Dac7Info';

const styles = makeStyles((theme) => ({
  button: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
  },
}));

const Dac7InfoContainer = () => {
  const classes = styles();
  const history = useHistory();
  const [showDialog, setShowDialog] = useState(false);
  const currentUser = useSelector(userData);
  const showDac7 = currentUser.has_reviewed_cottages || currentUser.dac7_valid;

  const handleOpenDialog = () => {
    setShowDialog(true);
    history.push('/orders/dac7/info');
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
    history.push('/orders');
  };

  useEffect(() => {
    if (showDac7 && history.location.pathname === '/orders/dac7/info') {
      setShowDialog(true);
    } else {
      setShowDialog(false);
    }
  }, [history.location.pathname]);

  return (
    showDac7 && (
      <Box display="flex" justifyContent="flex-end" p={2}>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={handleOpenDialog}
          size="small"
        >
          <FormattedMessage id="dac7.info" defaultMessage="DAC7 Info" />
        </Button>
        {showDialog && (
          <div>
            <Dac7InfoDialog onClose={handleCloseDialog} />
          </div>
        )}
      </Box>
    )
  );
};

export default Dac7InfoContainer;
